import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import 'datatables.net';
import swal from 'sweetalert';
import { ProtectAPi } from '../../../api/ProtectAPi';
import { SetPermission } from '../../../auth/SetPermission';
import AdminQuickNav from '../landingPage/AdminQuickNav';
import { ServerUrl } from '../../../api/ServerUrl';

const LandingProductList = () => {

  const { http } = ProtectAPi();
  const tableRef = useRef(null);

  const [tableData, setTableData] = useState([]);
  const userPermission = SetPermission();

  /* ================= FETCH PRODUCT LIST ================= */
  useEffect(() => {
    http.get('/get-landing-product-list')
      .then(res => {
        // 🔥 IMPORTANT: paginate() response
        setTableData(res.data.data || []);
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }, []);


  
  /* ================= INIT DATATABLE ================= */
  useEffect(() => {
    if (tableData.length > 0) {

      // destroy if already exists
      if ($.fn.DataTable.isDataTable('#table-1')) {
        $('#table-1').DataTable().destroy();
      }

      // init datatable
      $('#table-1').DataTable({
        pageLength: 10,
        ordering: true,
        destroy: true,
      });
    }
  }, [tableData]);

  /* ================= DELETE PRODUCT ================= */
  const handleDeleteProduct = (id) => {
    swal({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this product!',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        http.delete(`/delete-landing-product/${id}`)
          .then(res => {
            swal('Product deleted successfully!', {
              icon: 'success',
            }).then(() => {
              window.location.reload(); // 🔥 reload once
            });
          })
          .catch(() => {
            swal('Something went wrong!', { icon: 'error' });
          });
      }
    });
  };

  return (
    <div className="main-content" style={{ marginTop: -20 }}>
      <section className="section">
        <div className="section-body">
          <div className="row">
            <div className="col-12">

              {/* 🔥 REUSABLE NAV */}
              <AdminQuickNav active="products" />

              <div className="card">
                <div className="card-body">

                  <div className="d-flex justify-content-between mb-3">
                    <h5>Product List</h5>
                    <Link to="/admin/landing-page-product-add" className="btn btn-primary btn-md">
                      Add New Product
                    </Link>
                  </div>

                  <div className="table-responsive">
                    <table
                      className="table table-striped"
                      id="table-1"
                      ref={tableRef}
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product Image </th>
                          <th>Product Name</th>
                          <th>Article Number</th>
                          <th>Price</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {tableData.length === 0 && (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No products found
                            </td>
                          </tr>
                        )}

                        {tableData.map((data, index) => (
                          <tr key={data.id}>
                            <td>{index + 1}</td>
                            <td>
                              {data.images && data.images.length > 0 ? (
                                <img
                                  src={ServerUrl + data.images[0].image}
                                  alt={data.images[0].alt_text || data.product_name}
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                    objectFit: 'cover',
                                    borderRadius: '6px'
                                  }}
                                  className='p-1'
                                />
                              ) : (
                                <span className="text-muted">No Image</span>
                              )}
                            </td>

                            <td>{data.product_name}</td>
                            <td>{data.article_number}</td>
                            <td>{data.price}</td>
                            <td>
                              {data.status === 1
                                ? <span className="badge badge-primary">Active</span>
                                : <span className="badge badge-danger">De-Active</span>
                              }
                            </td>

                            <td>
                              {userPermission.includes('product_edit') && (
                                <Link
                                  to={`/admin/landing-page-product-edit/${data.id}`}
                                  className="editbtn mr-1"
                                >
                                  <button className="btn btn-warning">
                                    <i className="fas me-2 fa-edit text-white"></i>
                                  </button>
                                </Link>
                              )}

                              {userPermission.includes('product_delete') && (
                                <button
                                  className="btn btn-danger"
                                  onClick={() => handleDeleteProduct(data.id)}
                                >
                                  <i className="fas me-2 fa-trash text-white"></i>
                                </button>
                              )}
                            </td>

                            
                          </tr>
                        ))}
                      </tbody>

                    </table>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingProductList;
